<template>
  <div>
    <b-dropdown
      class="dropdown-filter-pembayaran"
      aria-role="menu"
      expanded
      append-to-body
      :close-on-click="false"
    >
      <template #trigger>
        <div class="is-relative">
          <p class="mb-1">{{title}}</p>
          <div class="input-filter-specific">
            <div class="is-flex is-align-items-center">
              <img
                :src="require('@/assets/icons/calendar-all-used.svg')"
                alt=""
              />
              <p class="averta-bold ml-1">
                {{
                  selectedDate
                    ? formatDate(selectedDate)
                    : placeholder
                }}
              </p>
            </div>
            <button
              v-if="selectedDate"
              class="delete xmark-button"
              @click="clearSelectedDate"
            />
            <a v-else class="card-header-icon p-0">
              <b-icon icon="menu-down"></b-icon>
            </a>
          </div>
        </div>
      </template>
      <div>
        <v-date-picker
          color="red"
          mode="date"
          v-model="selectedDate"
          is-expanded
          :is-range="isRange"
        />
      </div>
    </b-dropdown>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  name: 'DropdownDateSpecificSearch',
  props: {
    title: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    isRange: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedDate: null
    }
  },
  methods: {
    formatDate (date) {
      const format = 'dddd, DD MMMM YYYY'
      if (!date) return '-'
      if (this.isRange) {
        const { start, end } = date
        if (start.toString() === end.toString()) {
          return moment(start).format(format)
        }
        return `${moment(start).format(format)} - ${moment(end).format(
          format
        )}`
      }
      return moment(date).format(format)
    },
    clearSelectedDate () {
      this.selectedDate = null
    }
  },
  watch: {
    selectedDate (val) {
      this.$emit('select', val)
    }
  }
}
</script>

<style>
.dropdown-filter-pembayaran .dropdown-content {
  padding-bottom: 0 !important;
  padding-top: 0 !important;
}
</style>
